import { render } from "./EditOtherWork.vue?vue&type=template&id=9447c03e"
import script from "./EditOtherWork.vue?vue&type=script&lang=js"
export * from "./EditOtherWork.vue?vue&type=script&lang=js"

import "./EditOtherWork.vue?vue&type=style&index=0&id=9447c03e&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__